import React, { useRef } from 'react';
import {IProps} from './types';
import * as S from './styles';
import ArtBoardIcon from '@assets/icons/artBoardIcon';

const Layer:React.FC<IProps> = (props) => {
  const ref = useRef<null | any>(null);

  return (
    <S.AccordionItem key={`accordion-item-${props.index}`}>
      <S.AccordionTitle
        onClick={() => {
          props.onClick(props.index);
        }}
      >
        <S.ArrowDown style={!props.active?{transform: 'rotate(-90deg)'}:{}}/>
        <ArtBoardIcon style={{marginRight: '2px'}}/>
        <S.Title>{props.title}</S.Title>
      </S.AccordionTitle>
      <S.AccordionBody>
        {
          props.active && 
          <S.AccordionContent ref={ref}>
            {props.children} 
          </S.AccordionContent>
        }
      </S.AccordionBody>
    </S.AccordionItem>
  );
}

export default Layer;